import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  CreateItemLabelHTMLFromEncodedBase64,
  CreateItemLabelsHTMLProps,
} from "../components/printing/generate-item-label-html";
import { useDebugMode } from "../hooks/useDebugMode";

export interface ItemLabelGeneratorPageProps {
  autoPrint?: boolean;
}

const ItemLabelGeneratorPage = ({ autoPrint }: ItemLabelGeneratorPageProps) => {
  const location = useLocation();
  const [labelHTML, setLabelHTML] = useState<string[]>([]);
  const [error, setError] = useState<string>();

  const [hasShownPrint, setHasShownPrint] = useState<boolean>(false);
  const debugMode = useDebugMode();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    let encoded = false;
    let base64Data = queryParams.get("data");

    if (!base64Data) {
      if (queryParams.has("dataEncoded")) {
        base64Data = queryParams.get("dataEncoded");
        encoded = true;
      } else {
        setError("No data provided in query string.");
        return;
      }
    }

    let parsedData;
    try {
      const jsonString = atob(base64Data!);
      if (encoded) {
        parsedData = JSON.parse(
          decodeURIComponent(jsonString)
        ) as CreateItemLabelsHTMLProps;
      } else {
        parsedData = JSON.parse(jsonString) as CreateItemLabelsHTMLProps;
      }
    } catch (e) {
      setError("Invalid data format.");
      return;
    }

    const boxCount = parsedData.boxCount || 1;
    const labelPromises: Promise<string>[] = [];
    for (let i = 1; i <= boxCount; i++) {
      const labelData = { ...parsedData, currentBoxNumber: i, boxCount };
      const labelBase64 = btoa(encodeURIComponent(JSON.stringify(labelData)));
      labelPromises.push(
        CreateItemLabelHTMLFromEncodedBase64(labelBase64, debugMode)
      );
    }

    Promise.all(labelPromises)
      .then((labels) => {
        setLabelHTML(labels);
        if (autoPrint) {
          setTimeout(() => {
            if (hasShownPrint) return;
            window.print();
            setHasShownPrint(true);
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("Error generating label HTML:", error);
        setError("Error generating label HTML.");
      });
  }, [location.search, autoPrint, hasShownPrint, debugMode]);

  return (
    <>
      {error ? (
        <>
          <h5>Error</h5>
          <p>{error}</p>
        </>
      ) : null}
      {Array.isArray(labelHTML)
        ? labelHTML.map((html, i) => (
            <div
              className={
                i === labelHTML.length - 1
                  ? "item-label-print-page no-break"
                  : "item-label-print-page"
              }
              key={i}
              dangerouslySetInnerHTML={{ __html: html }}
            />
          ))
        : null}
    </>
  );
};

export default ItemLabelGeneratorPage;
